import React, { useEffect, useState } from 'react';
import {
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonText,
  useIonViewWillEnter,
} from '@ionic/react';
import { PageLayout } from 'containers/layout';

import {
  getCurrentLocation,
  watchLocation,
  clearWatch,
} from 'utils/geolocation';

function LocationTestPage() {
  const [loc, setLoc] = useState({});
  const [watch, setWatch] = useState({});
  const [error, setError] = useState(null);

  useIonViewWillEnter(async () => {
    const coords = await getCurrentLocation();
    setLoc(coords);
  });

  useEffect(() => {
    console.log(`=== Start location watch`);
    const waitId = watchLocation((coords, err) => {
      console.log(`=== Watch result`, coords, err);
      if (err) {
        setError(err);
      } else {
        setWatch(coords);
      }
    });

    return () => clearWatch(waitId);
  }, []);

  return (
    <PageLayout title="GeoLocation Test">
      {error && <IonText color="error">{JSON.stringify(error)}</IonText>}
      <IonList>
        <IonListHeader>Get Location</IonListHeader>
        <IonItem>
          <IonLabel>Latitude:</IonLabel>
          <IonText slot="end">{loc.lat}</IonText>
        </IonItem>
        <IonItem>
          <IonLabel>Longitude:</IonLabel>
          <IonText slot="end">{loc.lng}</IonText>
        </IonItem>
      </IonList>
      <IonList>
        <IonListHeader>Watch Location</IonListHeader>
        <IonItem>
          <IonLabel>Latitude:</IonLabel>
          <IonText slot="end">{watch.lat}</IonText>
        </IonItem>
        <IonItem>
          <IonLabel>Longitude:</IonLabel>
          <IonText slot="end">{watch.lng}</IonText>
        </IonItem>
      </IonList>
    </PageLayout>
  );
}

export default LocationTestPage;
